import { render, staticRenderFns } from "./_Select.vue?vue&type=template&id=24cc3edd"
import script from "./_Select.vue?vue&type=script&lang=js"
export * from "./_Select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports